import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ButtonComponent } from '../../../../common/components/button/button.component';

@Component({
  selector: 'app-delete-withdraw-dialog',
  standalone: true,
  imports: [MatDialogModule, CommonModule, MatButtonModule, ButtonComponent],
  providers: [MatDialogConfig],
  templateUrl: './delete-withdraw-dialog.component.html',
  styleUrl: './delete-withdraw-dialog.component.scss'
})
export class DeleteWithdrawDialogComponent {

  loggedUserId: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<DeleteWithdrawDialogComponent>,
    public dialog: MatDialog,
    public dialogConfig: MatDialogConfig
  ) {
 
    this.loggedUserId = localStorage.getItem("user_id");
  }

  withdrawPrompt() {
    let postData = {
      status: 'DRAFT_WITHDRAWN',
      curator_user_id: Number(this.loggedUserId),
      prompt_id: this.data?.prompt_id
    };
  
    this.dialogRef.close(postData);
  }

  deletePrompt() {
    this.dialogRef.close({prompt_id: this.data?.prompt_id});
  }

  cancelDeleteWithdraw() {
    this.dialogRef.close();
  }
}
